import './SurveySuccess.less';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import { setShowSurveySuccess } from '@/store/slices/home.js';
import Icon from '@/components/iconfont/Icon.jsx';
import { DISCORD_URL } from '@/pages/home/Home.jsx';
import { useTranslation } from 'react-i18next';

export default function SurveySuccess() {
  const showSurveySuccess = useSelector((state) => state.home.showSurveySuccess);
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (showSurveySuccess) {
      modalRef.current.show();
      dispatch(setShowSurveySuccess(false));
    }
  }, [showSurveySuccess]);

  function closeModal() {
    modalRef.current.close();
  }

  function toDiscord() {
    closeModal();
    window.open(DISCORD_URL, '_black');
  }

  return (
    <div className="survey-success-component">
      <dialog ref={modalRef} className="modal">
        <div className="modal-box">
          <form method="dialog">
            {/* if there is a button in form, it will close the modal */}
            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
          </form>

          <section>
            <div className="logo"></div>

            <p>{t('As_Survey_Thank')}</p>

            <button className="btn btn-primary btn-sm" onClick={closeModal}>
              {t('As_Survey_Start')}
            </button>
            <button className="btn btn-sm" onClick={toDiscord}>
              <Icon name="icon-discord"></Icon>
              {t('As_Survey_Discord')}
            </button>
          </section>
        </div>
      </dialog>
    </div>
  );
}
